// ============================================================================
// Condition Block Identifier
// ============================================================================

import type { ConditionBlockBoundary, ExtractedCondition } from '../types';
import { regexParser } from './regex-parser';

/**
 * Identifies and extracts condition blocks from Python code
 * Uses regex-based parsing (no AST dependencies)
 */
export class ConditionBlockIdentifier {
  /**
   * Finds all condition blocks in code (including commented ones)
   * @param {string} code - The Python code to search
   * @return {ConditionBlockBoundary[]} Array of condition block boundaries
   */
  findConditionBlocks(code: string): ConditionBlockBoundary[] {
    return regexParser.findConditionBlocks(code);
  }

  /**
   * Extracts conditions from code (simplified interface)
   * Only returns uncommented conditions
   * @param {string} code - The Python code to extract conditions from
   * @return {ExtractedCondition[]} Array of extracted conditions
   */
  extractConditions(code: string): ExtractedCondition[] {
    return regexParser.extractConditions(code);
  }
}

// Export singleton instance
export const blockIdentifier = new ConditionBlockIdentifier();
